import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import backend from '@lexian/api/support-api';

import {
  StyledMaintenanceMessage,
  StyledMaintenanceOverlay,
} from './MaintenanceOverlay.styles';

/**
 * Shows a full size overlay with a backdrop indicating that the application is in maintenance mode where we're
 * importing data.
 */
export const MaintenanceOverlay = (): React.ReactElement | null => {
  const {t} = useTranslation('common');
  const location = useLocation();

  const [active, setActive] = useState(false);

  useEffect(() => {
    backend.getMaintenanceStatus({
      parameters: {},
      onSuccess: ({body}) => {
        setActive(body.active);
      },
    });
  }, [location]);

  if (!active) {
    return null;
  }

  return (
    <StyledMaintenanceOverlay>
      <StyledMaintenanceMessage>
        {t('maintenance.message')}
      </StyledMaintenanceMessage>
    </StyledMaintenanceOverlay>
  );
};
